/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TaskTickOutline from './task-tick-outline.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TaskTickOutline {...validProps} />;
}

SvgComponent.iconName = 'taskTickOutline';

export const TaskTickOutlineIcon = svgIconWrapper(SvgComponent);
